import { matchPath } from 'react-router-dom';

export function isMatchPath(path: string): boolean {
    const fullPath = `${path}(/*)?`;

    return Boolean(matchPath(window.location.pathname, { path: fullPath }));
}
